export const CREATE_ROOM = `
  mutation CreateRoom($name: String!, $club: String!) {
      createRoom(name: $name, club: $club) 
  }
`;

export const ADD_USER_TO_ROOM = `
  mutation AddUserToRoom($userId: String!, $roomId: String!, $isPrivate: Boolean) {
      addUserToRoom(userId: $userId, roomId: $roomId, isPrivate: $isPrivate) 
  }
`;

export const REMOVE_USER_FROM_ROOM = `
  mutation RemoveUserFromRoom($userId: String!, $roomId: String!) {
      removeUserFromRoom(userId: $userId, roomId: $roomId) 
  }
`;

export const GET_USER_CHAT_ROOMS_INSPECTOR = `
  query ($userId: String!, $club: String!) {
    getUserChatRoomsInspector(userId: $userId, club: $club)
  }
`;

export const GET_USER_CHAT_ROOM_CONVERSATION_INSPECTOR = `
  query (
    $userId: String!,
    $roomId: String!,
    $limit: Int,
    $skip: Int
  ) {
    getUserChatRoomConversationInspector(
      userId: $userId,
      roomId: $roomId,
      limit: $limit,
      skip: $skip
    )
  }
`;
